
    /* eslint-disable */

    import {
        defineComponent, ref, unref
    } from 'vue';
    import useHotelOffersTariffPopupAdapter from '@ve/components/hotel/hotelOffersTariffsPopup/common/useHotelOffersTariffPopupAdapter';
    import HotelOffersTariffPopup from './HotelOffersTariffPopup.vue';

    export default defineComponent({
        name: 'hotel-offers-tariff-popup-adapter',
        components: {
            HotelOffersTariffPopup,
        },
        setup() {
            const {
                tariffs,
            } = useHotelOffersTariffPopupAdapter('hotelOffersTariffsStore');

            const hotelOffersTariffPopup = ref(null);

            const open = () => {
                unref(hotelOffersTariffPopup)?.open();
            };
            const close = () => {
                unref(hotelOffersTariffPopup)?.close();
            };

            return {
                tariffs,
                hotelOffersTariffPopup,
                open,
                close,
            };
        },
    });
